import script from "./PageTitleHome.vue?vue&type=script&setup=true&lang=js"
export * from "./PageTitleHome.vue?vue&type=script&setup=true&lang=js"

import "./PageTitleHome.vue?vue&type=style&index=0&id=7f0274ea&lang=scss&scoped=true"

import exportComponent from "D:\\work\\project\\week-alone\\weekly-alone-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f0274ea"]])

export default __exports__